import { useEffect, useState } from "react";
import api, { formatTL } from "@/lib/api";

const statuses = ["pending", "confirmed", "preparing", "shipped", "delivered", "cancelled"];
const statusLabel = {
  pending: "Onay Bekliyor", confirmed: "Onaylandı", preparing: "Hazırlanıyor",
  shipped: "Kargoya Verildi", delivered: "Teslim Edildi", cancelled: "İptal",
};

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/orders/${id}`, { status });
    load();
  };

  const filtered = filter === "all" ? orders : orders.filter((o) => o.status === filter);

  return (
    <div data-testid="admin-orders">
      <h1 className="font-display text-3xl font-extrabold tracking-tight mb-6">Siparişler</h1>
      <div className="flex gap-2 mb-5 flex-wrap">
        <button onClick={() => setFilter("all")} className={`px-3 py-1.5 rounded-full text-xs font-bold ${filter === "all" ? "bg-[#0077B6] text-white" : "bg-white border"}`}>Tümü</button>
        {statuses.map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`px-3 py-1.5 rounded-full text-xs font-bold ${filter === s ? "bg-[#0077B6] text-white" : "bg-white border"}`}>{statusLabel[s]}</button>
        ))}
      </div>

      <div className="space-y-3">
        {filtered.map((o) => (
          <div key={o.id} className="bg-white rounded-2xl border border-slate-100 p-5">
            <div className="flex flex-wrap justify-between gap-3 mb-3">
              <div>
                <div className="font-display font-extrabold text-lg">#{o.order_no}</div>
                <div className="text-xs text-slate-500">{new Date(o.created_at).toLocaleString("tr-TR")}</div>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-display text-xl font-extrabold text-[#0077B6]">{formatTL(o.total)}</span>
                <select value={o.status} onChange={(e) => updateStatus(o.id, e.target.value)} className="rounded-lg border border-slate-200 px-3 py-1.5 text-sm">
                  {statuses.map((s) => <option key={s} value={s}>{statusLabel[s]}</option>)}
                </select>
              </div>
            </div>
            <div className="text-sm text-slate-700">
              {(() => {
                const d = o.delivery || o.address || {};
                return (
                  <>
                    <div><strong>{d.full_name}</strong> · {d.phone} · {d.email}</div>
                    {d.otogar ? (
                      <div className="text-[#0077B6] font-semibold">🚌 Otogar: {d.otogar}</div>
                    ) : d.otogar_city ? (
                      <div className="text-[#0077B6] font-semibold">🚌 {d.otogar_city} — {d.otogar_name}</div>
                    ) : (
                      <div className="text-slate-500">{d.city} / {d.district} — {d.address_line}</div>
                    )}
                    {d.notes && <div className="text-xs text-slate-500 mt-1">Not: {d.notes}</div>}
                  </>
                );
              })()}
              <div className="mt-2 text-slate-600">{o.items.map((it) => `${it.name} × ${it.quantity}`).join(", ")}</div>
              <div className="text-xs text-slate-500 mt-2">Ödeme: {o.payment_method} {o.bus_fee ? `· Otobüs: ₺${o.bus_fee}` : ""}</div>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <div className="bg-white rounded-2xl p-10 text-center text-slate-600">Sipariş yok.</div>}
      </div>
    </div>
  );
}
